<template>
  <div class="vue-poll">
    <h3 class="qst" v-html="question"></h3>
    <div class="ans-cnt">
      <div
        v-for="(a, index) in calcAnswers"
        :key="index"
        :class="{ ans: true, [a.custom_class]: a.custom_class }"
      >
        <template v-if="!finalResults">
          <div
            v-if="!visibleResults"
            :class="{ 'ans-no-vote noselect': true, active: a.selected }"
            @click.prevent="handleVote(a)"
          >
            <span class="txt" v-html="a.text"></span>
          </div>
          <div v-else :class="{ 'ans-voted': true, selected: a.selected }">
            <span v-if="a.percent" class="percent" v-text="a.percent"></span>
            <span class="txt" v-html="a.text"></span>
          </div>

          <span class="bg" :style="{ width: visibleResults ? a.percent : '0%' }"></span>
        </template>
        <template v-else>
          <div :class="{ 'ans-voted': true, final: true, selected: a.selected }">
            <span v-if="a.percent" class="percent" v-text="a.percent"></span>
            <span class="txt" v-html="a.text"></span>
          </div>
          <span
            :class="{ bg: true, selected: mostVotes == a.votes }"
            :style="{ width: a.percent }"
          ></span>
        </template>
      </div>
    </div>
    <div
      class="votes"
      v-if="showTotalVotes && (visibleResults || finalResults)"
      v-text="$tc('feed.pollVotes', totalVotesFormatted)"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Poll",
  props: {
    question: {
      type: String,
      required: true,
    },
    answers: {
      type: Array,
      required: true,
    },
    showResults: {
      type: Boolean,
      default: false,
    },
    showTotalVotes: {
      type: Boolean,
      default: true,
    },
    finalResults: {
      type: Boolean,
      default: false,
    },

    submitButtonText: {
      type: String,
      default: "Submit",
    },
    customId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visibleResults: JSON.parse(this.showResults),
    };
  },
  computed: {
    totalVotes() {
      return this.answers.reduce(
        (prev, current) => (current.votes ? prev + current.votes : prev),
        0,
      );
    },
    totalVotesFormatted() {
      return this.totalVotes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    mostVotes() {
      let max = 0;
      this.answers.forEach((a) => {
        if (a.votes && a.votes >= max) {
          max = a.votes;
        }
      });
      return max;
    },
    calcAnswers() {
      if (this.totalVotes === 0) {
        return this.answers.map((a) => {
          const b = { ...a };
          b.percent = "0%";
          return b;
        });
      }

      // Calculate percent
      return this.answers.map((a) => {
        const b = { ...a };
        if (!Number.isNaN(a.votes) && a.votes > 0) {
          b.percent = `${Math.round((a.votes / this.totalVotes) * 100)}%`;
        } else {
          b.percent = "0%";
        }
        return b;
      });
    },
    totalSelections() {
      return this.calcAnswers.filter((a) => a.selected).length;
    },
  },
  methods: {
    handleVote(a) {
      const b = { ...a };
      b.votes += 1;
      b.selected = true;
      this.visibleResults = true;

      const obj = { value: b.value, votes: b.votes, totalVotes: this.totalVotes };

      if (this.customId) obj.customId = this.customId;

      this.$emit("addvote", obj);
    },
  },
};
</script>

<style>
.vue-poll {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.vue-poll .noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.vue-poll .qst {
  font-weight: normal;
}
.vue-poll .ans-cnt {
  margin: 20px 0;
}
.vue-poll .ans-cnt .ans {
  position: relative;
  margin-top: 8px;
  padding: 4px 0;
}
.vue-poll .ans-cnt .ans:first-child {
  margin-top: 0;
}

.vue-poll .ans-cnt .ans-no-vote {
  text-align: center;
  border: 2px solid var(--v-primary-base);
  box-sizing: border-box;
  border-radius: 100px;
  cursor: pointer;
  padding: 5px 0;
  transition: background 0.2s ease-in-out;
  -webkit-transition: background 0.2s ease-in-out;
  -moz-transition: background 0.2s ease-in-out;
}

.vue-poll .ans-cnt .ans-no-vote .txt {
  color: var(--v-primary-base);
  transition: color 0.2s ease-in-out;
  -webkit-transition: color 0.2s ease-in-out;
  -moz-transition: color 0.2s ease-in-out;
}

.vue-poll .ans-cnt .ans-no-vote.active {
  background: var(--v-primary-base);
}

.vue-poll .ans-cnt .ans-no-vote.active .txt {
  color: #fff;
}

.vue-poll .ans-cnt .ans-voted {
  padding: 5px 0;
}

.vue-poll .ans-cnt .ans-voted .percent,
.vue-poll .ans-cnt .ans-voted .txt {
  position: relative;
  z-index: 1;
}
.vue-poll .ans-cnt .ans-voted .percent {
  font-weight: bold;
  min-width: 51px;
  display: inline-block;
  margin: 0 10px;
}

.vue-poll .ans-cnt .ans-voted.selected {
  color: white;
}

.vue-poll .ans-cnt .ans-voted.selected .txt:after {
  content: "✔";
  color: white;
  margin-left: 10px;
}

.vue-poll .ans-cnt .ans .bg {
  position: absolute;
  width: 0%;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #e1e8ed;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
  -webkit-transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
  -moz-transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
}

.vue-poll .ans-cnt .ans .bg.selected {
  background-color: var(--v-primary-base);
}

.vue-poll .votes {
  font-size: 14px;
  color: #8899a6;
}
</style>
